import React, { useState, useEffect } from 'react';
import { showToast } from './Toast';

function Builder() {
  const [selectedBase, setSelectedBase] = useState('pure_orig');
  const [selectedFruits, setSelectedFruits] = useState([]);
  const [selectedCrunch, setSelectedCrunch] = useState([]);
  const [selectedSauce, setSelectedSauce] = useState('honey');
  const [orderNotes, setOrderNotes] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [isMember, setIsMember] = useState(false);
  const [showQRModal, setShowQRModal] = useState(false);

  const fruitLimit = 4;

  const basePrices = {
    pure_orig: { price: 49, name: 'Pure Scoop รสดั้งเดิม 70G' },
    pure_fruit: { price: 59, name: 'Pure Scoop รสผลไม้ 70G' },
    bowl_orig_s: { price: 69, name: 'Yogurt Bowl รสดั้งเดิม (S)' },
    bowl_orig_m: { price: 139, name: 'Yogurt Bowl รสดั้งเดิม (M)' },
    bowl_orig_l: { price: 169, name: 'Yogurt Bowl รสดั้งเดิม (L)' },
    bowl_fruit_s: { price: 79, name: 'Yogurt Bowl รสผลไม้ (S)' },
    bowl_fruit_m: { price: 159, name: 'Yogurt Bowl รสผลไม้ (M)' },
    bowl_fruit_l: { price: 189, name: 'Yogurt Bowl รสผลไม้ (L)' }
  };

  const fruits = [
    { id: 'mango', emoji: '🥭', name: 'มะม่วงสุก', desc: 'สดใหม่ รสหวานฉ่ำ' },
    { id: 'grape', emoji: '🍇', name: 'องุ่นไร้เมล็ด', desc: 'กรอบ หวานกำลังดี' },
    { id: 'apple', emoji: '🍎', name: 'แอปเปิ้ลฟูจิ', desc: 'กรุบกรอบ มีประโยชน์' },
    { id: 'kiwi', emoji: '🥝', name: 'กีวี่สด', desc: 'เปรี้ยวหวานลงตัว' },
    { id: 'blueberry', emoji: '🫐', name: 'บลูเบอร์รี่', desc: 'ซูเปอร์ฟู้ด ยอดฮิต' }
  ];

  const crunchOptions = [
    { id: 'oat', emoji: '🌾', name: 'โอ๊ตเฟล็กซ์', desc: '+฿10 อุดมด้วยไฟเบอร์' },
    { id: 'granola', emoji: '🥣', name: 'กราโนล่าโฮมเมด', desc: '+฿10 หอมน้ำผึ้งกรอบนาน' }
  ];

  useEffect(() => {
    const handleQuickMenu = (event) => {
      const { menuCode, price } = event.detail;

      setSelectedFruits([]);
      setSelectedCrunch([]);

      if (menuCode === 'MX') {
        setSelectedFruits(['mango', 'grape', 'apple', 'kiwi']);
        setSelectedBase('bowl_orig_l');
        setSelectedSauce('honey');
      } else if (menuCode === 'Mango Bliss') {
        setSelectedFruits(['mango', 'blueberry']);
        setSelectedBase('bowl_orig_m');
        setSelectedSauce('honey');
      } else if (menuCode === 'Oatflake Apple') {
        setSelectedFruits(['apple', 'blueberry']);
        setSelectedCrunch(['oat', 'granola']);
        setSelectedBase('bowl_orig_m');
        setSelectedSauce('honey');
      }

      setTimeout(() => {
        document.getElementById('builder')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);

      showToast(`โหลดสูตรด่วน "${menuCode}" ลงในกล่องตกแต่งแล้ว!`, true);
    };

    window.addEventListener('selectQuickMenu', handleQuickMenu);
    return () => window.removeEventListener('selectQuickMenu', handleQuickMenu);
  }, []);

  const toggleFruit = (fruitId) => {
    setSelectedFruits(prev =>
      prev.includes(fruitId)
        ? prev.filter(f => f !== fruitId)
        : [...prev, fruitId]
    );
  };

  const toggleCrunch = (crunchId) => {
    setSelectedCrunch(prev =>
      prev.includes(crunchId)
        ? prev.filter(c => c !== crunchId)
        : [...prev, crunchId]
    );
  };

  const calculateTotal = () => {
    let total = basePrices[selectedBase].price;

    const extraFruits = Math.max(0, selectedFruits.length - fruitLimit);
    total += extraFruits * 15;

    total += selectedCrunch.length * 10;

    return total;
  };

  const getFruitName = (fruitId) => {
    const fruit = fruits.find(f => f.id === fruitId);
    return fruit ? `${fruit.name} ${fruit.emoji}` : fruitId;
  };

  const getCrunchName = (crunchId) => {
    const crunch = crunchOptions.find(c => c.id === crunchId);
    return crunch ? `${crunch.name} ${crunch.emoji}` : crunchId;
  };

  const handleSubmitOrder = () => {
    const baseName = basePrices[selectedBase].name;
    const fruitsText = selectedFruits.length > 0
      ? selectedFruits.map(f => getFruitName(f).split(' ')[0]).join(', ')
      : 'ไม่ใส่ผลไม้';
    const crunchText = selectedCrunch.length > 0
      ? selectedCrunch.map(c => getCrunchName(c).split(' ')[0]).join(', ')
      : 'ไม่ใส่ท็อปปิ้งกรอบ';
    const sauceText = selectedSauce === 'honey' ? 'ราดน้ำผึ้งป่า' : 'ไม่เติมหวาน';
    const notesText = orderNotes || 'ไม่มี';
    const totalPrice = calculateTotal();
    const memberText = isMember ? 'สมาชิก DA\'VI' : 'ลูกค้าทั่วไป (ไม่ใช่สมาชิก)';

    const orderText = `✨ ออเดอร์ลูกค้า DA'VI (Sunday Dairy) ✨\n\n` +
      `👤 สถานะ: ${memberText}\n` +
      `📛 ชื่อ: ${customerName || '-'}\n` +
      `📞 เบอร์โทร: ${customerPhone || '-'}\n` +
      `📍 ที่อยู่จัดส่ง: ${customerAddress || '-'}\n\n` +
      `🥣 รายการเมนู:\n` +
      `• เมนู: ${baseName}\n` +
      `• ผลไม้: ${fruitsText}\n` +
      `• ท็อปปิ้งกรอบ: ${crunchText}\n` +
      `• ความหวาน: ${sauceText}\n` +
      `• หมายเหตุ: ${notesText}\n\n` +
      `💰 ยอดรวม: ฿${totalPrice}\n\n` +
      `--------------------------\n` +
      `ส่งข้อมูลนี้ให้ร้านทาง LINE Official: ST.DAVI ได้ทันทีนะคะ`;

    navigator.clipboard.writeText(orderText).then(() => {
      showToast('คัดลอกรายละเอียดคำสั่งซื้อแล้ว! กำลังเปิดหน้าต่างชำระเงิน QR');
      setShowQRModal(true);
    });
  };

  const renderBillItems = () => {
    const baseInfo = basePrices[selectedBase];
    const total = calculateTotal();

    return (
      <>
        <div className="flex justify-between">
          <span className="text-brand-200">🥛 {baseInfo.name}</span>
          <span className="font-semibold">฿{baseInfo.price}</span>
        </div>

        {selectedFruits.length > 0 && (
          <>
            <div className="mt-2 text-xs text-brand-300 font-medium">ผลไม้ที่เลือก:</div>
            {selectedFruits.map((fruit, idx) => {
              const isExtra = idx >= fruitLimit;
              return (
                <div key={fruit} className="flex justify-between pl-3 text-xs text-brand-100">
                  <span>- {getFruitName(fruit)}</span>
                  <span>{isExtra ? '+฿15' : 'ฟรี'}</span>
                </div>
              );
            })}
          </>
        )}

        {selectedCrunch.length > 0 && (
          <>
            <div className="mt-2 text-xs text-brand-300 font-medium">ท็อปปิ้งความกรอบ:</div>
            {selectedCrunch.map(crunch => (
              <div key={crunch} className="flex justify-between pl-3 text-xs text-brand-100">
                <span>- {getCrunchName(crunch)}</span>
                <span>+฿10</span>
              </div>
            ))}
          </>
        )}

        {selectedSauce === 'honey' && (
          <div className="flex justify-between mt-2 border-t border-brand-800/40 pt-2 text-xs text-brand-100">
            <span>🍯 เติมน้ำผึ้งป่าธรรมชาติ</span>
            <span className="text-brand-300">ฟรี</span>
          </div>
        )}
      </>
    );
  };

  return (
    <section id="builder" className="py-20 lg:py-24 bg-white border-b border-brand-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14 space-y-3">
          <div className="inline-flex items-center gap-2 text-brand-600">
            <span className="w-6 h-[1px] bg-brand-400"></span>
            <span className="text-[11px] uppercase tracking-[0.25em] font-bold">
              Artisan Bowl Builder
            </span>
            <span className="w-6 h-[1px] bg-brand-400"></span>
          </div>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-normal text-brand-900 tracking-tight">
            Design Your Own Bowl
          </h2>

          <p className="text-xs sm:text-sm text-brand-600/80 font-light">
            เลือกสรรเบสกรีกโยเกิร์ต ผลไม้สด และท็อปปิ้งพรีเมียมตามใจคุณ พร้อมส่งสั่งซื้อผ่าน LINE
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-7 bg-[#FAFCFE] p-6 sm:p-8 rounded-3xl border border-brand-200/80 shadow-xs space-y-8">

            <div>
              <span className="text-sm font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 1: เลือกขนาด & เบสโยเกิร์ต
              </span>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Pure Scoop 70G
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                {['pure_orig', 'pure_fruit'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        {base === 'pure_orig' ? 'รสดั้งเดิม (Pure Classic)' : 'รสผลไม้ (Berry Fruit)'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Yogurt Bowl รสดั้งเดิม <span className="text-[11px] font-normal text-brand-500">(ฟรีผลไม้ 4 ชนิด)</span>
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                {['bowl_orig_s', 'bowl_orig_m', 'bowl_orig_l'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        Size {base.includes('_s') ? 'S' : base.includes('_m') ? 'M' : 'L'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>

              <span className="text-xs font-semibold uppercase tracking-wider text-brand-800 block mt-4 mb-2">
                Yogurt Bowl รสผลไม้ <span className="text-[11px] font-normal text-brand-500">(ฟรีผลไม้ 4 ชนิด)</span>
              </span>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {['bowl_fruit_s', 'bowl_fruit_m', 'bowl_fruit_l'].map(base => (
                  <label key={base} className="relative flex items-center p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                    <input
                      type="radio"
                      name="base"
                      value={base}
                      checked={selectedBase === base}
                      onChange={(e) => setSelectedBase(e.target.value)}
                      className="sr-only peer"
                    />
                    <div className="flex flex-col flex-1">
                      <span className="font-semibold text-brand-900 text-xs sm:text-sm">
                        Size {base.includes('_s') ? 'S' : base.includes('_m') ? 'M' : 'L'}
                      </span>
                    </div>
                    <div className="text-right mr-3">
                      <span className="font-bold text-brand-700 block text-xs sm:text-sm">฿{basePrices[base].price}</span>
                    </div>
                    <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 inline-block shrink-0 transition-colors"></span>
                  </label>
                ))}
              </div>
            </div>

            <div>
              <div className="flex justify-between items-center mb-3">
                <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600">
                  Step 2: เลือกผลไม้สด (ฟรี 4 อย่าง เพิ่มอย่างละ ฿15)
                </span>
                <span className="text-[10px] bg-brand-600 text-white px-2.5 py-0.5 rounded-full font-bold uppercase tracking-wider">
                  ฟรี 4 ชนิด
                </span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                {fruits.map(fruit => (
                  <button
                    key={fruit.id}
                    onClick={() => toggleFruit(fruit.id)}
                    className={`p-3 bg-white border rounded-2xl text-left hover:border-brand-500 transition-all flex items-center space-x-2.5 shadow-2xs ${selectedFruits.includes(fruit.id) ? 'border-brand-600 bg-brand-100/60 ring-2 ring-brand-500/20' : 'border-brand-200/80'
                      }`}
                  >
                    <span className="text-xl">{fruit.emoji}</span>
                    <div className="flex-1">
                      <span className="text-xs font-semibold text-brand-900 block">{fruit.name}</span>
                      <span className="text-[10px] text-brand-500 font-light">{fruit.desc}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 3: เพิ่มท็อปปิ้งความกรุบกรอบ (+฿10)
              </span>
              <div className="grid grid-cols-2 gap-3">
                {crunchOptions.map(crunch => (
                  <button
                    key={crunch.id}
                    onClick={() => toggleCrunch(crunch.id)}
                    className={`p-3 bg-white border rounded-2xl text-left hover:border-brand-500 transition-all flex items-center space-x-2.5 shadow-2xs ${selectedCrunch.includes(crunch.id) ? 'border-brand-600 bg-brand-100/60 ring-2 ring-brand-500/20' : 'border-brand-200/80'
                      }`}
                  >
                    <span className="text-xl">{crunch.emoji}</span>
                    <div className="flex-1">
                      <span className="text-xs font-semibold text-brand-900 block">{crunch.name}</span>
                      <span className="text-[10px] text-brand-500 font-light">{crunch.desc}</span>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <div>
              <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-600 block mb-3">
                Step 4: เติมความหวาน (ฟรี 1 อย่าง)
              </span>
              <div className="grid grid-cols-2 gap-3">
                <label className="relative flex items-center justify-between p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                  <input
                    type="radio"
                    name="sauce"
                    value="honey"
                    checked={selectedSauce === 'honey'}
                    onChange={(e) => setSelectedSauce(e.target.value)}
                    className="sr-only peer"
                  />
                  <div className="flex items-center space-x-2.5">
                    <span className="text-lg">🍯</span>
                    <span className="text-xs font-semibold text-brand-900">น้ำผึ้งป่าธรรมชาติ</span>
                  </div>
                  <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 transition-colors"></span>
                </label>

                <label className="relative flex items-center justify-between p-3.5 bg-white border border-brand-200/80 rounded-2xl cursor-pointer hover:border-brand-500 transition-all shadow-2xs">
                  <input
                    type="radio"
                    name="sauce"
                    value="none"
                    checked={selectedSauce === 'none'}
                    onChange={(e) => setSelectedSauce(e.target.value)}
                    className="sr-only peer"
                  />
                  <div className="flex items-center space-x-2.5">
                    <span className="text-lg">❌</span>
                    <span className="text-xs font-semibold text-brand-900">ไม่รับความหวาน</span>
                  </div>
                  <span className="w-4 h-4 rounded-full border-2 border-brand-300 peer-checked:bg-brand-600 peer-checked:border-brand-600 transition-colors"></span>
                </label>
              </div>
            </div>
          </div>

          {/* Right Summary Column: Deep Aegean Navy matching screenshot */}
          <div className="lg:col-span-5 bg-[#0f1f38] text-white p-6 sm:p-7 rounded-3xl border border-[#223d66] sticky top-24 shadow-2xl flex flex-col justify-between space-y-6">
            <div>
              {/* Header: Cart Title + Membership Badge */}
              <div className="flex items-center justify-between pb-4 border-b border-[#1f375b]">
                {/* Left: Membership Text Switcher */}
                <div className="flex items-center space-x-1 text-xs sm:text-sm">
                  <button
                    type="button"
                    onClick={() => setIsMember(true)}
                    className={`transition-colors cursor-pointer font-medium ${isMember ? 'text-amber-400 font-semibold underline underline-offset-4' : 'text-[#8ca6cd] hover:text-white'
                      }`}
                  >
                    เป็นสมาชิก
                  </button>
                  <span className="text-[#506c94] px-0.5">/</span>
                  <button
                    type="button"
                    onClick={() => setIsMember(false)}
                    className={`transition-colors cursor-pointer font-medium ${!isMember ? 'text-white font-semibold underline underline-offset-4' : 'text-[#8ca6cd] hover:text-white'
                      }`}
                  >
                    ไม่ใช่สมาชิก
                  </button>
                </div>

                {/* Right: Add to Cart Title & Icon */}
                <div className="flex items-center space-x-2 text-white">
                  <svg className="w-5 h-5 text-emerald-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
                  </svg>
                </div>
              </div>

              {/* Menu Item Summary Row */}
              <div className="py-4 space-y-1.5 border-b border-[#1f375b]">
                <div className="flex justify-between items-baseline">
                  <span className="font-serif text-base sm:text-lg font-semibold tracking-wide text-white uppercase">
                    OLD SCHOOL
                  </span>
                  <span className="text-xs text-[#8ca6cd] font-light">จำนวน x1</span>
                  <span className="font-bold text-white text-base">฿{calculateTotal()}</span>
                </div>
                <div className="flex justify-between items-center text-xs text-[#6b85ac]">
                  <span className="truncate max-w-[220px]">
                    {selectedFruits.length > 0 || selectedCrunch.length > 0
                      ? [
                        selectedFruits.map(f => getFruitName(f).split(' ')[0]).join(', '),
                        selectedCrunch.map(c => getCrunchName(c).split(' ')[0]).join(', ')
                      ].filter(Boolean).join(' • ')
                      : 'รายละเอียดย่อยของเมนู'}
                  </span>
                  <span className="text-xs text-[#8ca6cd]">ฟรี</span>
                </div>
              </div>

              {/* Order Notes */}
              <div className="py-4 border-b border-[#1f375b] space-y-2">
                <label className="text-xs text-[#8ca6cd] block font-light">
                  หมายเหตุถึงร้านค้า (ถ้ามี):
                </label>
                <input
                  type="text"
                  value={orderNotes}
                  onChange={(e) => setOrderNotes(e.target.value)}
                  placeholder="เช่น ขอแอปเปิ้ลเยอะๆ, แยกน้ำผึ้ง..."
                  className="w-full bg-[#0a1526] border border-[#223d66] rounded-xl px-3.5 py-2.5 text-xs focus:outline-none focus:border-brand-400 text-white placeholder-[#506c94] transition-colors"
                />
              </div>

              {/* Delivery Info Inputs */}
              <div className="py-4 border-b border-[#1f375b] space-y-3">
                <div className="text-xs text-white font-medium">
                  กรุณากรอก
                  <span className="text-[11px] text-[#8ca6cd] font-light block">ที่อยู่ • เบอร์โทร • ชื่อ</span>
                </div>

                <div className="space-y-2">
                  <input
                    type="text"
                    value={customerName}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="ชื่อผู้รับ"
                    className="w-full bg-[#0a1526] border border-[#223d66] rounded-xl px-3.5 py-2 text-xs text-white placeholder-[#506c94] focus:outline-none focus:border-brand-400"
                  />
                  <input
                    type="tel"
                    value={customerPhone}
                    onChange={(e) => setCustomerPhone(e.target.value)}
                    placeholder="เบอร์โทรศัพท์"
                    className="w-full bg-[#0a1526] border border-[#223d66] rounded-xl px-3.5 py-2 text-xs text-white placeholder-[#506c94] focus:outline-none focus:border-brand-400"
                  />
                  <textarea
                    rows={2}
                    value={customerAddress}
                    onChange={(e) => setCustomerAddress(e.target.value)}
                    placeholder="ที่อยู่จัดส่งโดยละเอียด"
                    className="w-full bg-[#0a1526] border border-[#223d66] rounded-xl px-3.5 py-2 text-xs text-white placeholder-[#506c94] focus:outline-none focus:border-brand-400 resize-none"
                  />
                </div>
              </div>
            </div>

            {/* Total + Checkout Button */}
            <div className="space-y-4">
              <div className="flex justify-between items-end">
                <span className="text-xs text-[#8ca6cd] uppercase tracking-wider font-mono">
                  ESTIMATED TOTAL
                </span>
                <span className="font-serif text-3xl font-bold text-white flex items-baseline">
                  <span className="text-2xl mr-1 text-[#8ca6cd]">฿</span>
                  {calculateTotal()}
                </span>
              </div>

              <button
                onClick={handleSubmitOrder}
                className="w-full py-4 bg-[#141f30] hover:bg-[#1a293f] active:scale-[0.99] text-emerald-400 border border-[#223652] hover:border-emerald-500/50 font-bold rounded-2xl transition-all shadow-lg flex items-center justify-center space-x-2 text-sm uppercase tracking-[0.25em]"
              >
                <span>CHECK OUT</span>
              </button>

              <p className="text-[11px] text-[#6b85ac] text-center leading-relaxed font-light">
                ระบบต้องส่งไปที่ไลน์ OA เอง (ยังไม่มี)<br />
                กรุณาตรวจสอบข้อมูล
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* K SHOP PromptPay QR Code Modal with Exact Amount */}
      {showQRModal && (
        <div className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-[#0f1f38] border border-[#223d66] text-white rounded-3xl max-w-sm w-full p-6 text-center space-y-5 shadow-2xl animate-fade-in relative">
            <button
              onClick={() => setShowQRModal(false)}
              className="absolute top-4 right-4 text-[#8ca6cd] hover:text-white w-8 h-8 rounded-full bg-[#142640] flex items-center justify-center text-sm"
            >
              ✕
            </button>

            <div>
              <div className="inline-block bg-emerald-500/10 text-emerald-400 text-xs px-3 py-1 rounded-full border border-emerald-500/30 font-medium mb-2">
                K SHOP PromptPay
              </div>
              <h3 className="font-serif text-xl font-normal">สแกนชำระเงิน</h3>
              <p className="text-xs text-[#8ca6cd] mt-0.5">ยอดเงินล็อกตามบิลอัตโนมัติ</p>
            </div>

            {/* Dynamic PromptPay QR */}
            <div className="bg-white p-4 rounded-2xl inline-block shadow-inner">
              <img
                src={`https://promptpay.io/0944462974/${calculateTotal()}.png`}
                alt={`PromptPay QR ฿${calculateTotal()}`}
                className="w-48 h-48 object-contain mx-auto"
              />
            </div>

            <div className="space-y-1">
              <div className="text-xs text-[#8ca6cd]">ยอดชำระสุทธิ</div>
              <div className="font-serif text-3xl font-bold text-emerald-400">฿{calculateTotal()}</div>
              <div className="text-[11px] text-[#6b85ac]">พร้อมเพย์เบอร์ร้าน: 094-446-2974</div>
            </div>

            <div className="space-y-2 pt-2">
              <a
                href="https://line.me/R/ti/p/~ST.DAVI"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full py-3 bg-[#06C755] hover:bg-[#05b34c] text-white font-semibold rounded-xl text-xs flex items-center justify-center space-x-2 shadow-md transition-colors"
              >
                <i className="fab fa-line text-base"></i>
                <span>เปิดแชท LINE: ST.DAVI เพื่อส่งสลิป</span>
              </a>
              <button
                onClick={() => setShowQRModal(false)}
                className="w-full py-2.5 bg-[#142640] hover:bg-[#1a3152] text-[#8ca6cd] text-xs rounded-xl"
              >
                ปิดหน้าต่าง
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Builder;
